import { render, staticRenderFns } from "./checklist-task-list-checkbox.vue?vue&type=template&id=823dc45c&scoped=true"
import script from "./checklist-task-list-checkbox.vue?vue&type=script&lang=js"
export * from "./checklist-task-list-checkbox.vue?vue&type=script&lang=js"
import style0 from "./checklist-task-list-checkbox.vue?vue&type=style&index=0&id=823dc45c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823dc45c",
  null
  
)

export default component.exports